import { filter, map, Observable } from 'rxjs';
import { ProgressTypeEnum } from '../../enums/progress-type/progress-type.enum';
import { ProgressDone } from '../../models/progress-done/progress-done.model';
import { Progress } from '../../models/progress/progress.model';

export const extractProgressBody =
    <Body>() =>
    (source$: Observable<Progress<Body>>) => {
        return source$.pipe(
            filter(
                (progress): progress is ProgressDone<Body> =>
                    progress.type === ProgressTypeEnum.DONE,
            ),
            map((progressDone) => progressDone.data),
        );
    };
